import { render, staticRenderFns } from "./AppChangePassword.vue?vue&type=template&id=5e801c9b&scoped=true"
import script from "./AppChangePassword.vue?vue&type=script&lang=js"
export * from "./AppChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e801c9b",
  null
  
)

export default component.exports